import React, { useEffect, useState } from 'react';
import doctorsService from '../../services/doctors';
import branchesService from '../../services/branches';
import servicesService from '../../services/services';
import pagesService from '../../services/pages';
import { generateSitemap } from '../../utils/sitemapGenerator';

const SitemapDebug = () => {
  const [results, setResults] = useState({});
  const [sitemapTest, setSitemapTest] = useState(null);
  const [loading, setLoading] = useState(false);

  const testAPIs = async () => {
    setLoading(true);
    const tests = {};
    
    console.log("🧪 Starting API tests...");

    // Test doctors API
    try {
      console.log("🧪 Testing doctors API...");
      const doctors = await doctorsService.getAll("?status=ACTIVE");
      tests.doctors = { 
        success: true, 
        count: doctors?.data?.length || 0, 
        sample: doctors?.data?.[0] || null,
        fullResponse: doctors
      };
      console.log("✅ Doctors API success:", tests.doctors);
    } catch (error) {
      tests.doctors = { success: false, error: error.message, stack: error.stack };
      console.error("❌ Doctors API failed:", error);
    }

    // Test branches API
    try {
      console.log("🧪 Testing branches API...");
      const branches = await branchesService.getAll("?status=ACTIVE");
      tests.branches = { 
        success: true, 
        count: branches?.data?.length || 0, 
        sample: branches?.data?.[0] || null,
        fullResponse: branches
      };
      console.log("✅ Branches API success:", tests.branches);
    } catch (error) {
      tests.branches = { success: false, error: error.message, stack: error.stack };
      console.error("❌ Branches API failed:", error);
    }

    // Test services API
    try {
      console.log("🧪 Testing services API...");
      const services = await servicesService.getAll("?status=ACTIVE");
      tests.services = { 
        success: true, 
        count: services?.data?.length || 0, 
        sample: services?.data?.[0] || null,
        fullResponse: services
      };
      console.log("✅ Services API success:", tests.services);
    } catch (error) {
      tests.services = { success: false, error: error.message, stack: error.stack };
      console.error("❌ Services API failed:", error);
    }

    // Test pages/blogs API
    try {
      console.log("🧪 Testing pages API...");
      const pages = await pagesService.getAll("?category=6780be1dc8a5ce81775c05c2&status=ACTIVE");
      tests.pages = { 
        success: true, 
        count: pages?.data?.length || 0, 
        sample: pages?.data?.[0] || null,
        fullResponse: pages
      };
      console.log("✅ Pages API success:", tests.pages);
    } catch (error) {
      tests.pages = { success: false, error: error.message, stack: error.stack };
      console.error("❌ Pages API failed:", error);
    }

    setResults(tests);
    setLoading(false);
  };

  const testSitemapGeneration = async () => {
    setLoading(true);
    try {
      console.log("🧪 Testing full sitemap generation...");
      const sitemap = await generateSitemap();
      const urlCount = (sitemap.match(/<url>/g) || []).length;
      const hasDynamic = sitemap.includes('/doctor-booking-detail/') || 
                       sitemap.includes('/branch/') || 
                       sitemap.includes('/blogs/');
      
      setSitemapTest({
        success: true,
        urlCount,
        hasDynamic,
        sitemapLength: sitemap.length,
        preview: sitemap.substring(0, 1000) + '...'
      });
      console.log("✅ Sitemap generation success");
    } catch (error) {
      setSitemapTest({
        success: false,
        error: error.message,
        stack: error.stack
      });
      console.error("❌ Sitemap generation failed:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    testAPIs();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>🧪 Sitemap API Debug Tool</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testAPIs}
          disabled={loading}
          style={{ padding: '10px 20px', marginRight: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          {loading ? 'Testing...' : 'Test APIs'}
        </button>
        
        <button 
          onClick={testSitemapGeneration}
          disabled={loading}
          style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          {loading ? 'Testing...' : 'Test Sitemap Generation'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div>
          <h2>📡 API Test Results</h2>
          <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '4px', fontSize: '12px' }}>
            <pre>{JSON.stringify(results, null, 2)}</pre>
          </div>
        </div>

        <div>
          <h2>🗺️ Sitemap Test Results</h2>
          <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '4px', fontSize: '12px' }}>
            <pre>{JSON.stringify(sitemapTest, null, 2)}</pre>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>💡 Debug Tips</h3>
        <ul>
          <li>Check browser console for detailed logs</li>
          <li>Verify API endpoints are returning data</li>
          <li>Check if authentication tokens are available</li>
          <li>Compare results between /admin/sitemap-generator and /sitemap.xml</li>
        </ul>
      </div>
    </div>
  );
};

export default SitemapDebug;